import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import './assets/sass/style.scss';
import './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { RecoilRoot } from 'recoil';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </React.StrictMode>
);

serviceWorkerRegistration.register();